import React from "react";
import { trimText } from "utils";
import { Link } from "react-router-dom";
import homeIcon from "assets/images/icons/home-icon.svg";

export const Breadcrumb = ({
  isBreadCrumbsRequired = false,
  title,
  isBreadCrumbsMarginRequired = true,
  breadcrumb = [],
}) => {
  return (
    <>
      {isBreadCrumbsRequired && (
        <div
          className={`breadcrumb-element ${
            title || !isBreadCrumbsMarginRequired ? "" : "inner-page-breadcrumb"
          }`}
        >
          <nav className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item" style={{ lineHeight: "1" }}>
                <Link to="/">
                  <img src={homeIcon} alt="" />
                </Link>
              </li>
              {breadcrumb?.map((item, idx) => {
                if (breadcrumb?.length <= 1) {
                  return (
                    <li key={idx} className="breadcrumb-item active">
                      {trimText(item?.label)}
                    </li>
                  );
                }
                return (
                  <li
                    key={idx}
                    className={`${
                      item?.location ? "" : "active"
                    } breadcrumb-item`}
                  >
                    {item?.location ? (
                      <Link to={item?.location}> {trimText(item?.label)}</Link>
                    ) : (
                      trimText(item?.label)
                    )}
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>
      )}
    </>
  );
};
